import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import AiHintCard from "./AiHintCard";
import { UiProvider } from "@/context/UiContext";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <UiProvider>
      <div className="min-h-screen flex flex-col bg-cream">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <AiHintCard />
      </div>
    </UiProvider>
  );
}